import { jsx, jsxs } from "react/jsx-runtime";
import { VisuallyHidden } from "@zillow/constellation";
import React, { useRef, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useSyncFetchHistory, fetchApiResponse } from "./MortgageRateTrends.utils.esm.js";
import RateHistoryTable from "./RateHistoryTable.esm.js";
const MortgageRateHistoryTable = ({
  id,
  flavor
}) => {
  var _a, _b, _c;
  const form = useFormContext();
  const results = useSyncFetchHistory(form, flavor);
  const ratesByProgram = useRef(null);
  const errorMessage = useRef(null);
  useEffect(() => {
    fetchApiResponse(results).then((response) => {
      ratesByProgram.current = response;
    }).catch((e) => {
      errorMessage.current = e.message;
    });
  }, [results]);
  return /* @__PURE__ */ jsx(VisuallyHidden, { id, as: "figcaption", children: errorMessage == null ? /* @__PURE__ */ jsx("p", { children: "Historical rates are temporarily unavailable. We should restore them very soon." }) : /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsxs("p", { children: [
      "There are ",
      (_a = results == null ? void 0 : results.checkedLoanProgramFields) == null ? void 0 : _a.length,
      " ",
      "plot lines describing the rates for",
      " ",
      results == null ? void 0 : results.checkedLoanProgramFields.toString(),
      "."
    ] }),
    /* @__PURE__ */ jsxs("p", { children: [
      "The following tables describe the",
      " ",
      (_b = results == null ? void 0 : results.checkedLoanProgramFields) == null ? void 0 : _b.length,
      " lines in more detail."
    ] }),
    ((_c = ratesByProgram.current) == null ? void 0 : _c.rates) != void 0 && (results == null ? void 0 : results.checkedLoanProgramFields.map((program) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
      return /* @__PURE__ */ jsx(RateHistoryTable, { program, stateAbbreviation: ((_d = (_c2 = (_b2 = (_a2 = ratesByProgram.current) == null ? void 0 : _a2.rates) == null ? void 0 : _b2[program]) == null ? void 0 : _c2.query) == null ? void 0 : _d.stateAbbreviation) ?? null, loanAmountBucket: ((_h = (_g = (_f = (_e = ratesByProgram.current) == null ? void 0 : _e.rates) == null ? void 0 : _f[program]) == null ? void 0 : _g.query) == null ? void 0 : _h.loanAmountBucket) ?? null, loanToValueBucket: ((_l = (_k = (_j = (_i = ratesByProgram.current) == null ? void 0 : _i.rates) == null ? void 0 : _j[program]) == null ? void 0 : _k.query) == null ? void 0 : _l.loanToValueBucket) ?? null, samples: ((_o = (_n = (_m = ratesByProgram.current) == null ? void 0 : _m.rates) == null ? void 0 : _n[program]) == null ? void 0 : _o.samples) ?? null, refinance: ((_p = results == null ? void 0 : results.currentFieldValues) == null ? void 0 : _p.loanPurpose) == "Refinance", durationDays: (_q = results == null ? void 0 : results.currentFieldValues) == null ? void 0 : _q.timeSpan, creditScoreBucket: ((_u = (_t = (_s = (_r = ratesByProgram.current) == null ? void 0 : _r.rates) == null ? void 0 : _s[program]) == null ? void 0 : _t.query) == null ? void 0 : _u.creditScoreBucket) ?? null }, program);
    }))
  ] }) });
};
export {
  MortgageRateHistoryTable as default
};
